import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  FormBuilder } from '@angular/forms';
import { AuthService } from '../_services';



@Component({
    selector: 'configuration',
    templateUrl: './configurationmenu.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})
export class ConfigurationMenuComponent implements OnInit{

   //isadmin= false;
   isProfileAvailable= false;
   isUsersAvailable= false;
   isTemplatesAvailable = false;
   isBatchAvailable = false;
   isNotificationAvailable = false;
   isEventAvailable = false;
   isApiAvailable = false;
   isWebHookAvailable = false;
 /**
 * constructor function is used to initialize 
 */
constructor(
 
   private _fb: FormBuilder
   ,private router: Router
   ,private route: ActivatedRoute
   , private auth: AuthService
      ) 
   {   
      //this. isadmin= false;
       
    
   }
   ngOnInit() {
      // let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
      // let browserStorage = localStorage.getItem('isadmin');
      // if (browserStorage1 == null) {
      // if (browserStorage == null || browserStorage == '' || browserStorage == undefined) 
      // {
      //    this.isadmin = false;
      // } 
      // else if (browserStorage == 'true')
      // {  
      //  this.isadmin = true;
         
      // }
      // else
      // {
      //    this.isadmin = false;
      // }
      // }
      // else
      // {
         
      //    if(browserStorage =='true')
      //      {
          
      //       this.isadmin = true;   
      //      }
      //      else
      //      {
           
      //       this.isadmin = false;   
      //      }
      // }
      this.checkThisPageGrants();
   }

   async checkThisPageGrants() {
      await this.auth.isKashioGrantsAvailable();
      this.isProfileAvailable = this.auth.checkGrants('CONFIGURATIONS', 'PROFILE')
      this.isUsersAvailable = this.auth.checkGrants('CONFIGURATIONS', 'USERS')
      this.isTemplatesAvailable = this.auth.checkGrants('CONFIGURATIONS', 'TEMPLATES');
      this.isBatchAvailable = this.auth.checkGrants('CONFIGURATIONS', 'BATCH');
      this.isNotificationAvailable = this.auth.checkGrants('CONFIGURATIONS', 'NOTIFICATIONS');
      this.isEventAvailable = this.auth.checkGrants('CONFIGURATIONS', 'EVENTS');
      this.isApiAvailable = this.auth.checkGrants('CONFIGURATIONS', 'INTEGRATIONS');
      this.isWebHookAvailable = this.auth.checkGrants('CONFIGURATIONS', 'INTEGRATIONS');
   }
}